import cppLogo from '../Assets/cppLogo.svg';
import flutterLogo from "../Assets/flutterLogo.svg";
import javascriptLogo from "../Assets/javascriptLogo.svg";
import pythonLogo from "../Assets/pythonLogo.svg";
import reactLogo from "../Assets/reactLogo.svg";
import tensorflowLogo from "../Assets/tensorflowLogo.svg";

const SkillsData = [
    {
        name: "Python",
        icon: pythonLogo,
        text: "Programming and Scripting Language",
        link: ""
    },
    {
        name: "JavaScript",
        icon: javascriptLogo,
        text: "Programming Language",
        link: ""
    },
    {
        name: "C++",
        icon: cppLogo,
        text: "Programming Language",
        link: ""
    },
    {
        name: "TensorFlow",
        icon: tensorflowLogo,
        text: "Python Machine Learning Framework",
        link: ""
    },
    {
        name: "React",
        icon: reactLogo,
        text: "JavaScript Web Development Library",
        link: ""
    },
    {
        name: "Flutter",
        icon: flutterLogo,
        text: "Mobile Developement Framework",
        link: ""
    }
];

export default SkillsData;



// WEBPACK FOOTER //
// ./src/Components/Technologies/Data/SkillsData.js